
export const SET_BOOKING_LIST = 'SET_BOOKING_LIST';
export const SET_STATUS_LIST = 'SET_STATUS_LIST';
export const SET_NAV_PARAMS = 'SET_NAV_PARAMS';
export const UPDATE_BOOKINGS = 'UPDATE_BOOKINGS';